import {useState} from 'react';
import messages from '../messages';
import {
  ArchiveMaterialRequest,
  useArchiveMaterialMutation,
} from '../store/endpoints/archive-material';
import {useListSlice} from 'features/table/slice';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {parseValidationErrors} from 'services/api/utils/parse-error';
import toast from 'store/ui/actions/toast';
import {ObjectId} from 'types/object-id';

const __DEV__ = process.env.NODE_ENV === 'development';

export const useMaterialDeleteForm = (
  onDismiss: () => void,
  materialId: ObjectId
) => {
  const [archiveMaterial, {isLoading, error}] = useArchiveMaterialMutation();
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const serverError = parseValidationErrors(error);
  const {actions} = useListSlice();
  const name = 'materials';
  const url = 'materials';
  const handleSubmit = async () => {
    const result = await archiveMaterial(params);
    if ('data' in result) {
      dispatch(toast('success', t(...messages.materialArchivedSuccess())));
      dispatch(actions.clearSelection(name));
      dispatch(actions.loadData({url, name}));
      onDismiss();
    }
  };

  const [params, setParams] = useState<Params>({
    id: materialId,
  });

  return {
    setParams,
    params,
    isLoading,
    validationErrors: serverError.errors,
    errorMessage: serverError.message,
    submit: handleSubmit,
  };
};
type Params = ArchiveMaterialRequest;
